





































































































































































































































































































































































import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Board, Layer, LayerType } from '../../../common/board';
import { Project } from '../../../common/project';
import { boardSubmitSimulation } from '../simulation';
import { exportToCSV, DatabaseHeader } from './admin/tables/database';
import BoardDetailsCard from '@/BoardDetailsCard.vue';
import CentralViewCard from '@/CentralViewCard.vue';
import FavoriteBoardsCard from '@/shared/FavoriteBoardsCard.vue';
import gql from 'graphql-tag';

import * as PROJECT_QUERY from 'src/graphql/Project.graphql';
import * as LAYER_STUB_FRAGMENT_QUERY from 'src/graphql/LayerStubFragment.graphql';
import * as BOARD_RESULT_FRAGMENT_QUERY from 'src/graphql/BoardResultFragment.graphql';
import * as BOARDS_FRAGMENT_QUERY from 'src/graphql/BoardsFragment.graphql';
import * as BOARD_VISIBLE_FRAGMENT_QUERY from 'src/graphql/BoardVisibleFragment.graphql';
import * as BOARD_NAME_FRAGMENT_QUERY from 'src/graphql/BoardNameFragment.graphql';

@Component({
  components: {
    BoardDetailsCard,
    FavoriteBoardsCard
  }
})
export default class BoardsCard extends mixins(CentralViewCard) {
  $refs: any;

  get project() {
    return this.$store.state.currentProject;
  }

  name = 'BoardsCard';

  hovered = -1;

  favoritesDialog = false;
  selectedFavoriteBoard = null;

  deleteBoardDialog = -1;

  editNameDialog = -1;
  editName = '';

  fluteNotFound = false;
  paperNotFound = false;

  boardHeaders = [
    { text: 'Visible',               value: 'visible',              sortable: false, align: 'center', width: '48px', export: false, class: 'text-xs-center px-3' },
    { text: 'Name',                  value: 'name',                 sortable: false, align: 'center',                export: true,  class: 'text-xs-center fixed-name-width' },
    { text: '',                      value: 'name_edit',            sortable: false, align: 'center', width: '48px', export: false, class: 'text-xs-center empty-header' },
    { text: 'BPI',                   value: 'bpi',                  sortable: false, align: 'center', width: '48px', export: true,  class: 'text-xs-center px-3', tooltip: 'Board Performance Index', feature: 'Board Performance Index' },
    { text: 'BCT (N)',               value: 'bct',                  sortable: false, align: 'center', width: '48px', export: true,  class: 'text-xs-center px-4' },
    { text: 'Weight (g/m²)',         value: 'grammage',             sortable: false, align: 'center',                export: true,  class: 'text-xs-center' },
    { text: 'Thickness (mm)',        value: 'thickness',            sortable: false, align: 'center',                export: true,  class: 'text-xs-center' },
    { text: 'ECT (kN/m)',            value: 'ect',                  sortable: false, align: 'center',                export: true,  class: 'text-xs-center' },
    { text: 'Bend. Stiff. MD (Nm)',  value: 'bending_stiffness_MD', sortable: false, align: 'center',                export: true,  class: 'text-xs-center' },
    { text: 'Bend. Stiff. CD (Nm)',  value: 'bending_stiffness_CD', sortable: false, align: 'center',                export: true,  class: 'text-xs-center' },
    { text: 'Burst (kPa)',           value: 'burst',                sortable: false, align: 'center',                export: true,  class: 'text-xs-center pr-0' },
    { text: '',                      value: 'delete',               sortable: false, align: 'center', width: '48px', export: false, class: 'text-xs-center empty-header' },
    { text: '',                      value: 'expand',               sortable: false, align: 'center', width: '48px', export: false, class: 'text-xs-center pl-0 pr-2' },
  ];

  get boards() {
    return this.project && this.project.boards ? this.project.boards : [];
  }

  created() {
    this.name = 'BoardsCard';
  }

  mouseOver(index) {
    this.hovered = index;
  }

  mouseLeave() {
    this.hovered = -1;
  }

  @Watch('project')
  onProjectChanged() {
    for (let board of this.boards) {
      board.updateEnableSimulation();
    }
  }

  closeDeleteDialog() {
    this.deleteBoardDialog = -1;
  }

  closeFavoritesDialog() {
    this.favoritesDialog = false;
  }

  useFavoriteBoard() {
    this.createNewBoardFromFavorite(this.selectedFavoriteBoard);

    this.selectedFavoriteBoard = null;
    this.favoritesDialog = false;
  }

  openEditNameDialog(board) {
    this.editName = board.name;
    this.editNameDialog = board.index;

    setTimeout(() => {
      const input = this.$refs['editNameRef' + board.index];
      if (input) {
        input.focus();
        input.$el.querySelector('input').select()
      }
    }, 50);
  }

  closeEditNameDialog() {
    this.editNameDialog = -1;
    this.editName = '';
  }

  onExport() {
    let headers: DatabaseHeader[] = [];
    let values = [];

    for (const boardHeader of this.boardHeaders) {
      if (!boardHeader.export)
        continue;

      headers.push({
        text: boardHeader.text,
        value: boardHeader.value,
      });
    }

    headers.push({
      text: "Outer Liner",
      value: "layer0",
    },{
      text: "Fluting",
      value: "layer1",
    },{
      text: "Liner",
      value: "layer2",
    },{
      text: "Fluting",
      value: "layer3",
    },{
      text: "Liner",
      value: "layer4",
    },{
      text: "Fluting",
      value: "layer5",
    },{
      text: "Liner",
      value: "layer6",
    });

    for (const board of this.boards) {
      let row = {};
      for (const boardHeader of this.boardHeaders) {
        if (!boardHeader.export)
          continue;

        if (boardHeader.value == 'name') {
          row[boardHeader.value] = board.name;
        } else if (boardHeader.value == 'bpi') {
          if (board.use_custom_bpi)
            row[boardHeader.value] = `${board.custom_bpi} (custom)`;
          else
            row[boardHeader.value] = board.cached_default_bpi != null ? board.cached_default_bpi : '-';
        } else if (!board.hasBoardResults() ||
            board.hasSimulationErrors() ||
            (boardHeader.value == 'bct' && !board.hasSimulationSuccess())) {
          row[boardHeader.value] = '-';
        } else {
          row[boardHeader.value] = board.simulationResults[0][boardHeader.value];
        }
      }

      for (let i = 0; i < board.layers.length; i++) {
        const layer = board.layers[i];

        if (layer.paper != null)
          row['layer' + String(i)] = layer.paper.CEPI_name;
        else
          row['layer' + String(i)] = '-';


        if (!this.layerIsPaper(layer)) {
          if (layer.flute != null)
            row['layer' + String(i)] += ` [${layer.flute.name}]`;
          else
            row['layer' + String(i)] += ` [-]`;
        }
      }

      for (let i = board.layers.length; i < 7; i++) {
        row['layer' + String(i)] = ``;
      }

      values.push(row);
    }

    exportToCSV('Boards', headers, values);
  }

  numberOfNewBoardCard() {
    if ( this.boards.length == 0 )
      return 1;

    //assume sorted array
    const lastName = this.boards[this.boards.length-1].name;
    const res = lastName.split('-');

    if ( res.length < 2 )
      return 1;

    const highestValue = res[res.length-1];
    return 1 + parseInt(highestValue);
  }

  getNextBoardName() {
    return this.project.name + '-' + this.numberOfNewBoardCard();
  }

  createNewBoardFromFavorite(favoriteBoard) {
    let board = new Board();
    board.name = this.getNextBoardName();
    board.description = `From favorite board "${favoriteBoard.name}"`;

    for (const layer of favoriteBoard.layers) {
      board.layers.push( layer );
    }

    this.createNewBoard(board, favoriteBoard.id);
  }

  createNewEmptyBoard(numLayers) {
    let board = new Board();
    board.name = this.getNextBoardName();

    for (let i = 0; i < numLayers; i++) {
      let layer = new Layer();
      layer.type = i % 2 == 0 ? LayerType[LayerType.PAPER] : LayerType[LayerType.FLUTING];
      board.layers.push( layer );
    }

    this.createNewBoard(board);
  }

  createNewBoard(board, favoriteBoardId = null) {
    let dbBoard = board.asDatabaseBoard();
    let responseBoard = board.asResponseBoard();

    this.$apollo.mutate({
      mutation: gql`mutation ($id: Int!, $input: BoardInput!, $favoriteBoardId: Int) {
          projectCreateBoard(id: $id, input: $input, favoriteBoardId: $favoriteBoardId) {
            id
            name
            description
            visible
            use_custom_bpi
            custom_bpi
            cached_default_bpi
            layers {
              ...LayerStub
            }
            ...BoardResult
          }
        }
        ${LAYER_STUB_FRAGMENT_QUERY}
        ${BOARD_RESULT_FRAGMENT_QUERY}
      `,
      variables: {
        id: this.project.id,
        input: dbBoard,
        favoriteBoardId: favoriteBoardId,
      },
      update: (store, {data: { projectCreateBoard }}) => {
        let data: any = store.readFragment({
          id: `Project:${this.project.id}`,
          fragment: BOARDS_FRAGMENT_QUERY,
          fragmentName: 'Boards'
        });

        data.boards.push(projectCreateBoard);

        store.writeFragment({
          id: `Project:${this.project.id}`,
          fragment: BOARDS_FRAGMENT_QUERY,
          fragmentName: 'Boards',
          data
        });

        if (projectCreateBoard.id !== -1) {
          this.$set(this.$refs.boardsTable.expanded, projectCreateBoard.id, true);

          if (favoriteBoardId != null) {
            let paperIsNull = false;
            let fluteIsNull = false;

            for (const layer of projectCreateBoard.layers) {
              if (layer.paper == null) {
                paperIsNull = true;
              }

              if (!this.layerIsPaper(layer) && layer.flute == null) {
                fluteIsNull = true;
              }
            }

            if (paperIsNull) {
              this.paperNotFound = true;
            }

            if (fluteIsNull && !paperIsNull) {
              this.fluteNotFound = true;
            }
          }
        }
      },
      optimisticResponse: {
        __typename: 'Mutation',
        projectCreateBoard: {
          ...responseBoard
        },
      },
    });
  }

  layerIsPaper(layer) {
    return layer.type === LayerType[LayerType.PAPER];
  }

  deleteBoard(board) {
    this.$apollo.mutate({
      mutation: gql`mutation ($id: Int!, $boardId: Int!) {
          projectDeleteBoard(id: $id, boardId: $boardId)
        }
      `,
      variables: {
        id: this.project.id,
        boardId: board.id,
      },
      update: (store, {data: { projectDeleteBoard }}) => {
        let data: any = store.readFragment({
          id: `Project:${this.project.id}`,
          fragment: BOARDS_FRAGMENT_QUERY,
          fragmentName: 'Boards'
        });

        data.boards = data.boards.filter(
          result => result.id !== projectDeleteBoard
        );

        store.writeFragment({
          id: `Project:${this.project.id}`,
          fragment: BOARDS_FRAGMENT_QUERY,
          fragmentName: 'Boards',
          data
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        projectDeleteBoard: board.id
      },
    });

    this.closeDeleteDialog();
  }

  saveEditName(board) {
    if (this.editName != '') {
      this.$apollo.mutate({
        mutation: gql`mutation ($projectId: Int!, $boardId: Int!, $name: String!) {
            updateBoardName(projectId: $projectId, boardId: $boardId, name: $name) {
              ...BoardName
            }
          }
          ${BOARD_NAME_FRAGMENT_QUERY}
        `,
        variables: {
          projectId: this.project.id,
          boardId: board.id,
          name: this.editName,
        },
        update: (store, {data: { updateBoardName }}) => {
          let data = JSON.parse(JSON.stringify(board));
          data.name = updateBoardName.name;

          store.writeFragment({
            id: `Board:${board.id}`,
            fragment: BOARD_NAME_FRAGMENT_QUERY,
            data: data,
          });

        },
        optimisticResponse: {
          __typename: 'Mutation',
          updateBoardName: {
            __typename: 'Board',
            name: this.editName,
          },
        },
      });

      this.closeEditNameDialog();
    }
  }

  async onSubmitSimulations(e) {
    const outdated = this.$store.state.outdatedSimulationParameters;

    if (outdated)
      await this.project.eraseSimulationResults(this.$apollo);

    for (const board of this.boards) {
      if (board.activeSimulation)
        continue;

      if ((!board.hasSimulationSuccess() || outdated) && board.enableSimulation)
        boardSubmitSimulation(board, this.project, this.$store);
    }
  }

  toggleVisible(board) {
    this.$apollo.mutate({
      mutation: gql`mutation ($projectId: Int!, $boardId: Int!, $visible: Boolean!) {
          updateBoardVisible(projectId: $projectId, boardId: $boardId, visible: $visible) {
            ...BoardVisible
          }
        }
        ${BOARD_VISIBLE_FRAGMENT_QUERY}
      `,
      variables: {
        projectId: this.project.id,
        boardId: board.id,
        visible: !board.visible,
      },
      update: (store, {data: { updateBoardVisible }}) => {
        let data = JSON.parse(JSON.stringify(board));
        data.visible = updateBoardVisible.visible;

        store.writeFragment({
          id: `Board:${board.id}`,
          fragment: BOARD_VISIBLE_FRAGMENT_QUERY,
          data: data,
        });

      },
      optimisticResponse: {
        __typename: 'Mutation',
        updateBoardVisible: {
          __typename: 'Board',
          visible: !board.visible,
        },
      },
    });
  }

  async onSubmitSimulation(board) {
    boardSubmitSimulation(board, this.project, this.$store);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BoardsCard.vue